export const DATA_DETAILS_OPEN_MODAL = "DATA_DETAILS_OPEN_MODAL";
export const DATA_DETAILS_CLOSE_MODAL = "DATA_DETAILS_CLOSE_MODAL";